import { render, staticRenderFns } from "./WorkSpace.vue?vue&type=template&id=39f2f421&scoped=true&"
import script from "./WorkSpace.vue?vue&type=script&lang=js&"
export * from "./WorkSpace.vue?vue&type=script&lang=js&"
import style0 from "./WorkSpace.vue?vue&type=style&index=0&id=39f2f421&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2f421",
  null
  
)

export default component.exports